import { IProduct } from "../types/product";

import { translate } from "./translation.service";

export const getProductLabel = (product: IProduct): string => {
  const { isNew, isTopVente, isIncontournable } = product;

  if (isNew) {
    return translate("product.new");
  }
  if (isTopVente) {
    return translate("product.topSale");
  }
  if (isIncontournable) {
    return translate("product.mustHave");
  }

  return "";
};

export const getProductAvailabilityLabel = (
  availabilityLabel: string | undefined
): string | undefined => {
  if (!availabilityLabel) {
    return availabilityLabel;
  }

  const labelKey = {
    "En stock": "inStock",
    "Fin de Stock": "outOfStock",
    "Bientot disponible": "soonAvailable",
    "Bientôt disponible": "soonAvailable",
    "Rupture definitive": "definitelyUnavailable",
    "Rupture définitive": "definitelyUnavailable",
    "Sur demande": "onDemand",
  };

  const label = labelKey[availabilityLabel];

  if (!label) {
    return availabilityLabel;
  }

  return translate(`product.availabilityLabel.${label}`);
};
